var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 113,
    viewBox: "0 0 120 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.906 55.517C119.819 75.9754 103.715 89.7575 86.5932 96.8635C69.4714 103.97 50.9119 100.065 30.9148 85.1507C10.9177 70.2361 8.13935 53.5689 22.5798 35.1491C37.0203 16.7293 52.1792 3.00816 68.0566 -6.01425C83.934 -15.0367 102.817 -12.1516 124.704 2.64083C146.592 17.4333 149.993 35.0587 134.906 55.517Z",
    fill: "url(#paint0_linear_6_4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.879 54.4192C124.196 73.0124 110.535 85.4482 95.8976 91.7266C81.2598 98.005 65.2172 94.1321 47.77 80.1081C30.3227 66.0841 27.6777 50.7083 39.8351 33.9807C51.9925 17.2531 64.8397 4.8591 78.3768 -3.20119C91.9138 -11.2615 108.219 -8.32147 127.293 5.61883C146.367 19.5591 149.562 35.8259 136.879 54.4192Z",
    fill: "url(#paint1_linear_6_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_4",
    x1: 87.2078,
    y1: 6.64843,
    x2: 56.375,
    y2: 47.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.460384,
    stopColor: "#FF8743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F76B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD6B19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_4",
    x1: 95.0615,
    y1: 8.7383,
    x2: 46.1383,
    y2: 97.1172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.460384,
    stopColor: "#F89B67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F76B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68341"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob1);
export default __webpack_public_path__ + "static/media/blob1.0d5369bb791d8dc7b25410a5fe553ece.svg";
export { ForwardRef as ReactComponent };